import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Row, Col, Table, Input, Carousel, Form, notification, message, Image, Modal, Typography, Pagination, Tooltip, } from "antd";
import { EyeOutlined, LeftOutlined, RightOutlined, SendOutlined, } from "@ant-design/icons";
import { fileZipService, loadingPlanService } from "../../../services";
import TextArea from "antd/es/input/TextArea";
import { ROLES } from "../../../constants";
import dayjs from "dayjs";
import { RiGalleryLine } from "react-icons/ri";
import { RiDeleteBin6Line } from "react-icons/ri";
import 'cropperjs/dist/cropper.css';
import { Cropper } from 'react-cropper';
import { RxCrop } from "react-icons/rx";
import VehicleImageModal from "../../../components/ViewModal";
import { BsBoxSeam } from "react-icons/bs";
import { AiOutlineDownload } from "react-icons/ai";
import { FiCopy } from "react-icons/fi";
import { HiCheck } from "react-icons/hi";
import { GrGallery } from "react-icons/gr";
import { PiImagesSquareBold } from "react-icons/pi";
import { changeDocumentTitle } from "../../../utils/title";

const { Title } = Typography
const CustomArrow = {
    position: "absolute",
    top: "45%",
    color: "black",
    backgroundColor: "#F2F8FB", // Corrected background syntax
    border: "none",
    padding: "5px",
    borderRadius: "100%", // Corrected the border-radius syntax
    cursor: "pointer",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center"

};
function ViewLoadPlan() {

    const { id } = useParams();
    const [form] = Form.useForm()
    const role = localStorage.getItem('role')

    const carouselRef = useRef(null);
    const cropperRef = useRef(null);

    const [showImageModal, setShowImageModal] = useState(false);
    const [showViewImageModal, setViewShowImageModal] = useState(false);
    const [viewImage, setViewImage] = useState("");
    const [cropImage, setCropImage] = useState("");
    const [showCropModal, setShowCropModal] = useState(false);

    const [modalVisible, setModalVisible] = useState(false)
    const [emailLogs, setEmailLogs] = useState([]);
    const [showForm, setShowForm] = useState(false)
    const [mailLoading, setMailLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [loadingPlan, setLoadingPlan] = useState([]);
    const [Containers, setContainers] = useState([]);
    const [images, setImages] = useState([]);
    const [vehicleImages, setVehicleImages] = useState([]);
    const [copied, setCopied] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });

    const fieldData = [
        { label: "Container ID", value: loadingPlan.container_id },
        { label: "Location", value: loadingPlan.location },
        { label: "Destination", value: loadingPlan?.destination?.toUpperCase() },
        { label: "Container Size", value: loadingPlan.container_size },
        { label: "Booking No", value: loadingPlan.c_booking_number },
        { label: "Container No", value: loadingPlan.c_container_number },
        { label: "Posted on", value: dayjs(loadingPlan.created_at).format("DD-MMM-YYYY") },
    ];

    const handleCopy = (chasisNo) => {
        if (chasisNo) {
            navigator.clipboard.writeText(chasisNo);
            setCopied(chasisNo);
            setTimeout(() => setCopied(false), 1500);
        }
    };


    const columns = [
        {
            title: " S.no",
            dataIndex: " S.no",
            key: " S.no",
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: <span className="text-left block">Vehicle</span>,
            dataIndex: ["vehicle", "vehicle"],
            key: "Vehicle",
            render: (text, record) => (
                <span className='block text-left'>
                    {record.vehicle?.vehicle}
                </span>
            )
        },
        {
            title: <span className="text-left block">Product / Model</span>,
            dataIndex: ["vehicle", "product"],
            key: "Weight",
            render: (text, record) => (
                <span className='block text-left'>
                    {record.vehicle?.product}
                </span>
            )
        },
        {
            title: <span className="text-left block">Chassis No</span>,
            dataIndex: ["vehicle", "chasis_no"],
            key: "Chassis_no",
            render: (text, record) => {
                return (

                    <span className=' text-left flex gap-3 items-center'>
                        {record.vehicle?.chasis_no}
                        <button
                            onClick={() => handleCopy(record?.vehicle?.chasis_no)}
                            className="p-1 rounded-md hover:bg-gray-100 active:scale-90 transition relative group"
                        >
                            {copied === record?.vehicle?.chasis_no ? (
                                <HiCheck size={16} className="text-green-500" />
                            ) : (
                                <Tooltip title="Copy">
                                    <FiCopy size={16} className="text-gray-500" />
                                </Tooltip>
                            )}
                            {/* <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] text-white bg-black px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
                            Copy
                        </span> */}
                        </button>
                    </span>
                )

            }

        },
        {
            title: <span className="text-left block">Engine Type</span>,
            dataIndex: ["vehicle", "engine_type"],
            key: "Engine_Type",
            render: (text, record) => (
                <span className='block text-left'>
                    {record.vehicle?.engine_type}
                </span>
            )
        },
        {
            title: <span className="text-left block">Value</span>,
            dataIndex: ["vehicle", "value"],
            key: "Value",
            render: (text, record) => (
                <span className='block text-left'>
                    $ {record.vehicle?.value}
                </span>
            )
        },
        {
            title: <span className="text-left block">Weight</span>,
            dataIndex: ["vehicle", "weight"],
            key: "Weight",
            render: (text, record) => (
                <span className='block text-left'>
                    {record.vehicle?.weight}
                </span>
            )
        },


        {
            title: <span className="text-left block">Action</span>,
            key: "Action",
            render: (text, record, { _id }) => {
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span
                            style={{
                                backgroundColor: "#F1F5F9",
                                borderRadius: "10px",
                                color: "black",
                                padding: "1px 10px",
                                textAlign: "center",
                                fontSize: "12px",
                            }}
                        >
                            <Link to={`/operations/loadings/vehicle-details/${record.v_id}`} target="_blank" className="hover:text-primary">
                                {record.offload_count} Off Load
                            </Link>
                        </span>

                        <Link to={`/vehicles/${record.vehicle.id}`} className="hover:text-primary">
                            <Tooltip title="View">
                                <EyeOutlined style={{ fontSize: "15px" }} />
                            </Tooltip>
                        </Link>
                    </div>
                )
            },
        },
    ]
    const columns2 = [
        {
            title: " S.no",
            dataIndex: " S.no",
            key: " S.no",
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: "Date & Time",
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => (
                <>
                    {dayjs(text).format("hh:mm A")} <br />
                    {dayjs(text).format("MMM DD, YYYY")}
                </>
            )
        },
        {
            title: "Sender",
            dataIndex: "sender",
            key: "sender"
        },
        {
            title: "Receiver",
            dataIndex: "receiver",
            key: "receiver",
            render: (text) => text
                .split(',')
                .map((email, index) => <div key={index}>{email.trim()}</div>)
        },
        {
            title: "Subject",
            dataIndex: "log",
            key: "log"
        }
    ]


    const handleDownload = async () => {
        setDownloadLoading(true)
        const imagesPath = images.map((i) => i.image);
        const response = await fileZipService.download(id, imagesPath);
        setDownloadLoading(false)
        if (response?.success ?? false) {
            message.success(response.message)
        } else {
            message.error(response?.message ?? "Something Wrong")
        }
    }

    // const handleModalImageDownload = async (type, index = 0) => {
    //   setDownloadLoading(true);
    //   let response;

    //   if (type === 'single') {
    //     response = await fileZipService.download("hi", [images[index].filename]);
    //   }
    //   //  else {
    //   //   const imagesPath = images.map((i) => i.filename);
    //   //   response = await fileZipService.download("hi", imagesPath);
    //   // }

    //   setDownloadLoading(false);
    //   if (response?.success ?? false) {
    //     message.success(response.message);
    //   } else {
    //     message.error(response?.message ?? 'Something went wrong');
    //   }
    // }

    // const downloadMenu = (index) => ({
    //   items: [
    //     {
    //       key: '1',
    //       label: 'Download This Image',
    //       onClick: () => handleModalImageDownload('single', index),
    //     },
    //     {
    //       key: '2',
    //       label: 'Download All Images',
    //       onClick: () => handleDownload(),
    //     },
    //   ],
    // });

    const handleCrop = () => {
        const imageElement = cropperRef?.current;
        const cropper = imageElement?.cropper;

        if (cropper) {
            const croppedCanvas = cropper.getCroppedCanvas();
            const croppedDataUrl = croppedCanvas.toDataURL(); // base64 image
            console.log("Cropped Image:", croppedDataUrl);
            // Trigger download
            const link = document.createElement('a');
            link.href = croppedDataUrl;
            link.download = 'cropped-image.png'; // You can customize the filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setShowCropModal(false);
        }
    };

    const sendMail = async (val) => {
        setMailLoading(true)
        const emails = (val.emails + ', ' + val.extra_emails)
        const data = {
            ...val,
            container_id: loadingPlan.container_id,
            booking_number: loadingPlan.c_booking_number,
            emails: emails
        }
        delete data.extra_emails

        const response = await loadingPlanService.sendmail(data);
        setMailLoading(false)
        if (response.success) {
            notification.success({
                message: response.message,
                placement: "topRight"
            })
            setShowForm(false)
            form.resetFields()
        }
        initialize();
    }

    const initialize = async (page = 1, pageSize = pagination.current) => {
        const { success, data } = await loadingPlanService.View(id, page);
        if (success) {
            const { container, containers, email_logs, email } = data;
            setLoadingPlan(container);
            setEmailLogs(email_logs);
            form.setFieldsValue(
                {
                    emails: email,
                    subject: `C TRADE LOAD PLAN BOOKING # : ${container.c_booking_number}`,
                    // link: window.location.href
                    link: window.location.origin + "/customers-portal/load-plan/views/" + id
                }
            )
            if (loadingPlan) {
                setImages(container.myimages);
            }

            const vehicleimgs = containers.data.map((i) => ({
                id: i.vehicle.id,
                name: i.vehicle.vehicle,
                images: i.vehicle.images,
                chasis: i.vehicle.chasis_no
            }));

            setVehicleImages(vehicleimgs)

            setContainers(containers.data.filter(i => i.vehicle != null));
            setPagination((prev) => ({
                ...prev,
                total: containers.total,
                current: page,
                pageSize,
            }));
        }
    };

    useEffect(() => {
        changeDocumentTitle(" View Load Plan");
        initialize(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize]);

    const RenderTitle = ({ title }) => (
        <>
            {title}<span style={{ color: 'red', fontSize: '12px', marginLeft: 5 }}> (comma separate multiple emails)</span>
        </>
    );

    return (
        <>
            <Row gutter={24}>
                <Col span={24}>
                    <div className="flex justify-between items-center mb-6">
                        <Title level={4} style={{ padding: 0, margin: 0 }}>Loading Container</Title>
                        <div className="flex gap-3 w-[50%]">
                            {(role !== ROLES.CUSTOMER) &&
                                <>
                                    {/* <div style={{ textAlign: "center", marginTop: 10, marginBottom: 10 }}> */}
                                    <Button type="primary" onClick={() => setShowForm(true)} className=" w-full h-10 rounded-xl text-xs" >Send Mail</Button>
                                    {/* </div> */}
                                    <Modal
                                        width={650}
                                        open={showForm}
                                        onCancel={() => setShowForm(false)}
                                        footer={null}
                                    >
                                        <Form
                                            layout="vertical"
                                            form={form}
                                            onFinish={sendMail}
                                            initialValues={{
                                                cc_emails: "cservice@ctrade.us , rehan@ctrade.us , adnan@ctrade.us , tariq@ctrade.us ,  cs1@ctrade.us , OPERATIONS@ctrade.us , trade@ctrade.us , ac@ctrade.us , ac1@ctrade.us , CS2@CTRADE.US , CS4@CTRADE.US , cs3@ctrade.us",
                                                message: "Dear Customer, \nPlease find the mentioned link below to get your load plan details along with images.",
                                            }}
                                        >
                                            <Row gutter={24} style={{ padding: 10 }}>
                                                <Col span={12}>
                                                    <Form.Item label={<RenderTitle title="To" />} name="emails">
                                                        <Input readOnly style={{ border: 'none' }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label={<RenderTitle title="" />} name="extra_emails">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label="CC" name="cc_emails">
                                                        <TextArea rows={2} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label="Subject" name="subject">
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={12}>
                                                    <Form.Item label="Message" name="message">
                                                        <TextArea rows={2} readOnly style={{ border: 'none' }} />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={12}>
                                                    <Form.Item label="Comment" name="comment">
                                                        <TextArea rows={2} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item label="Link" name="link">
                                                        <Input readOnly style={{ border: 'none' }} />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={24}>
                                                    <div style={{ textAlign: "center", marginBottom: 10 }}>
                                                        <Button htmlType="submit" type="primary" loading={mailLoading}>
                                                            <SendOutlined /> Send
                                                        </Button>
                                                    </div>
                                                </Col>

                                            </Row>
                                        </Form>
                                    </Modal>
                                </>
                            }
                            <Button
                                type="primary"
                                loading={downloadLoading}
                                onClick={handleDownload}
                                className=" w-full h-10 rounded-xl text-xs"
                                icon={<AiOutlineDownload style={{ fontSize: "20px" }} />}
                            >
                                Download All Images
                            </Button>
                            <Button
                                // type="primary"
                                variant="outlined"
                                icon={<PiImagesSquareBold style={{ fontSize: "20px" }} />}
                                className="w-full text-xs h-10 rounded-xl"
                                onClick={() => setModalVisible(true)}
                            >
                                Compare Images
                            </Button>
                        </div>
                    </div>
                </Col>
                <Col span={15}
                // style={{
                //     position: "sticky",
                //     top: 0,
                // }}
                >
                    {/* <p
            onClick={() => setShowImageModal(true)}
            style={{ fontWeight: "bold", fontSize: "14px", color: "white", backgroundColor: "#FFA952" }} className="flex justify-evenly items-center p-3 rounded-xl">
            <span><RiGalleryLine style={{ fontSize: "18px" }} /></span>Pending Images
          </p> */}
                    <div className="relative border border-[#ccc] rounded-lg flex justify-center items-center flex-col w-[100%] p-2"
                    // className="carousel-container"
                    >
                        {images.length > 0 ?
                            <>
                                <div style={{ textAlign: "center", position: "relative", width: "100%" }}>
                                    <Carousel ref={carouselRef}
                                        className="w-full "
                                        style={{ width: "100%" }}
                                    >
                                        {
                                            images.map((image, index) => (
                                                <Image.PreviewGroup items={images.map((i) => i.image)}>
                                                    <Image
                                                        key={index}
                                                        src={image.image}
                                                        alt="Profile"
                                                        style={{
                                                            borderRadius: "8px",
                                                            objectFit: "cover",
                                                            width: "100%",
                                                            height: "578px", // Fixed height for uniformity
                                                            margin: "auto",
                                                        }}
                                                    />
                                                </Image.PreviewGroup>
                                            ))
                                        }
                                    </Carousel>
                                    <button style={{ ...CustomArrow, left: "10px", }}
                                        onClick={() => carouselRef.current?.prev()}>
                                        <LeftOutlined style={{ fontSize: "16px" }} />
                                    </button>

                                    {/* Right Button */}
                                    <button style={{ ...CustomArrow, right: "10px", }}
                                        onClick={() => carouselRef.current?.next()}>
                                        <RightOutlined style={{ fontSize: "16px" }} />
                                    </button>
                                </div>

                            </> : <div style={{ textAlign: "center", fontSize: 20 }}><h1>No Images Available</h1></div>
                        }

                    </div>
                </Col>

                <Col span={9}>
                    <div className="bg-[#FFFFFF] rounded-lg border border-[#ccc] p-4">
                        <div className="flex flex-col gap-4">
                            <div className="flex justify-between items-center">
                                <p className="m-0 p-0 flex gap-1 font-bold text-sm items-center"><span><BsBoxSeam style={{ color: 'red' }} /></span>Container summary</p>
                                <span className="border rounded-2xl bg-[#F1F5F9] px-2 py-1 text-[12px] ">
                                    Last update, {dayjs(loadingPlan.updated_at).format("DD-MMM-YYYY")}
                                </span>

                            </div>
                            {fieldData.map((field, index) => (

                                <div className="flex flex-col w-full border border-[#d9d9d9] rounded-xl gap-1 p-3" >
                                    <span className="text-xs text-[#62748E]">
                                        {field.label}
                                    </span>
                                    <span className="font-semibold">
                                        {field.value}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>

                <Col span={24}>
                    <div className="customer1-table-wrapper mt-6">

                        <Table
                            columns={columns}
                            scroll={{ x: "max-content" }}
                            dataSource={Containers}
                            style={{ marginTop: "2px" }}
                            pagination={false}
                        // footer={() => (
                        //     <div className="flex justify-between items-center text-xs mt-2 mb-2 px-2">
                        //         <div className=" text-gray-600">
                        //             Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                        //             {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                        //             {pagination.total} entries
                        //         </div>
                        //         <Pagination
                        //             current={pagination.current}
                        //             total={pagination.total}
                        //             pageSize={pagination.pageSize}
                        //             showSizeChanger={false}
                        //             onChange={(page) => initialize(page, pagination.pageSize)}
                        //             itemRender={(current, type, originalElement) => {
                        //                 if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                        //                 if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                        //                 return originalElement;
                        //             }}
                        //         />
                        //     </div>
                        // )}
                        />
                    </div>
                    {(role !== ROLES.CUSTOMER) &&
                        <div className="customer1-table-wrapper mt-6">

                            <Table
                                columns={columns2}
                                scroll={{ x: "max-content" }}
                                dataSource={emailLogs}
                                style={{ marginTop: "2px" }}
                                pagination={false}
                            />
                        </div>
                    }
                </Col>
            </Row >

            {/* pending images modal */}
            <VehicleImageModal
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                containerImages={images}
                vehicles={Containers.map((i) => i.vehicle)}
            />

            <Modal
                title={<div className="mt-5 text-center border-t-2 border-gray-400 p-5">Pending Images</div>}
                open={showImageModal}
                onCancel={() => setShowImageModal(false)}
                footer={
                    <div className="flex justify-center mt-3 items-center">
                        <Button type="primary" className="w-1/3">Approve</Button>
                    </div>
                }
                width={800}
                bodyStyle={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingRight: "10px",
                }}
            >
                {images.length > 0 ? (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "18px", justifyContent: "center" }}>
                        {images.map((image, index) => (
                            <div key={image.id} style={{ position: "relative" }}>
                                <Image
                                    src={image.image}
                                    alt={`Image ${index + 1}`}
                                    width={120}
                                    height={120}
                                    preview={false} // No preview
                                    style={{
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                        border: "1px solid #ccc",
                                    }}
                                    onClick={() => {
                                        // setCropImage(image.image);
                                        setViewImage(image.image)
                                        setViewShowImageModal(true)
                                        // setShowCropModal(true);
                                    }}
                                />
                                <span
                                    onClick={() => {
                                        setImages(images.filter((_, i) => i !== index));
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: "0px",
                                        right: "1px",
                                        borderRadius: "50%",
                                        width: "18px",
                                        height: "18px",
                                        color: "white",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                        boxShadow: "0 0 4px rgba(0,0,0,0.2)",
                                        zIndex: 10,
                                    }}
                                    className="bg-gray-600"
                                >
                                    <RiDeleteBin6Line />
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ textAlign: "center", fontSize: "16px" }}>
                        <p>No Images Available</p>
                    </div>
                )}
            </Modal>

            {/* view image modal */}
            <Modal
                title={<div className="mt-2 p-2"></div>}
                open={showViewImageModal}
                onCancel={() => setViewShowImageModal(false)}
                onClose={true}
                footer={null}
                width={450}
                bodyStyle={{
                    maxHeight: "500px",
                    overflowY: "auto",
                }}
            >
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div className="relative">
                        <Image
                            src={viewImage}
                            width={350}
                            height={250}
                            preview={false} // No preview
                            style={{
                                objectFit: "cover",
                                borderRadius: "8px",
                                cursor: "pointer",
                            }}
                        />
                        <div className="flex gap-2 absolute bottom-3 right-1">
                            {/* <Button icon={<FiDownload />} /> */}
                            <Button icon={<RxCrop />} onClick={() => {
                                setShowCropModal(true);
                                setCropImage(viewImage);
                            }}> crop Image</Button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* cropped Image */}
            <Modal
                title="Crop Image"
                open={showCropModal}
                onCancel={() => setShowCropModal(false)}
                footer={null}
                width={650}
            >
                <Cropper
                    src={cropImage}
                    style={{ height: 340, width: '100%' }}
                    initialAspectRatio={NaN}
                    aspectRatio={NaN}
                    guides={true}
                    viewMode={1}
                    dragMode="none"
                    scalable={true}
                    cropBoxResizable={true}
                    cropBoxMovable={true}
                    responsive={true}
                    autoCropArea={1}
                    ref={cropperRef}
                />

                <div className="flex justify-center mt-3">
                    <Button type="primary" onClick={handleCrop}>
                        Done
                    </Button>
                </div>
            </Modal>
        </>
    );
}
export default ViewLoadPlan;
